import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './Global.css';
import store from './redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LocaleProvider } from './i18n/localeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GoogleOAuthProvider clientId="864154840542-9hr01rddanlojdlr8s21d9mflpc790k8.apps.googleusercontent.com">
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </BrowserRouter>
    </Provider>
  </GoogleOAuthProvider>
);